require('../../../node_modules/moment/moment');
require('../../../node_modules/pc-bootstrap4-datetimepicker/build/js/bootstrap-datetimepicker.min.js');
require('../../../node_modules/easy-autocomplete/dist/jquery.easy-autocomplete.min.js');

$(function () {
  var owl = $(".owl-carousel-rs");
  owl.owlCarousel({
    items: 3,
    loop: true,
    margin: 26,
    stagePadding: 168,
    arrowKeys: false,
    nav: false,
    dots: false,
    move: 1,
    lazyload: true,
    autoplayButton: false,
    autoplayTimeout: 6000,
    autoplaySpeed: 6000,
    autoplay: true,
    mouseDrag: true,
    autoplayHoverPause: true,
    navText: [
        '<img width="11" height="10" src="https://cdn1.myassignmenthelp.store/lazyload-assets/2021/cms_images/slider_arrow_left.svg" />',
        '<img width="11" height="10" src="https://cdn1.myassignmenthelp.store/lazyload-assets/2021/cms_images/slider_arrow_right.svg" />'
    ],
    responsive: {
      0: {
        items: 1,
        margin: 0,
        stagePadding: 0,
        nav: true,
      },

      640: {
        items: 1,
        margin: 10,
        stagePadding: 0,
        nav: true,
      },
      768: {
        items: 2,
        margin: 15,
        stagePadding: 50,
        nav: false,
      },
      992: {
        items: 2,
        margin: 26,
        stagePadding: 168,
        nav: false,
      },
      1025: {
        items: 3,
        margin: 26,
        stagePadding: 168,
        nav: false,
      },
      1479: {
        items: 5,
        margin: 26,
        stagePadding: 168,
        nav: false,
      },
    }
  });
	$('#datetimepicker6').datetimepicker({
		//  debug:true,
		keepOpen: true,
        ignoreReadonly: true,
        widgetPositioning: {
            vertical: "bottom"
          },
		icons: {
			time: "timeIcon",
			date: "calendarIcon",
			up: "topArrow",
			down: "bottomArrow",
			previous: "leftArrow",
			next: "rightArrow"
		},
		format: "MM/DD/YYYY h:mm A",
		minDate:new Date()
    });

    $('#datetimepickerNew').datetimepicker({
		// debug:true,
		keepOpen: true,
        ignoreReadonly: true,
		icons: {
			time: "timeIcon",
			date: "calendarIcon",
			up: "topArrow",
			down: "bottomArrow",
			previous: "leftArrow",
			next: "rightArrow"
		},
		format: "MM/DD/YYYY h:mm A",
		minDate:new Date()
	});

	var options = {
		url: DOMAIN_NAME + "front/website-auto-subject.json",
	    list: {
	      match: {
	        enabled: true
	      }
	    }
	};
	$(".init-autocomplete").easyAutocomplete(options);

var countTime = 0;
var myInterval = setInterval(myAppend, 500);
  function myAppend() {
    if(countTime == 1){
      clearInterval(myAppend);
    } else{
      countTime++;
      function insertAfter(referenceNode, newNode) {
        referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
      }
      var el = document.createElement("label");
      var span = document.createElement("span");
      el.appendChild(span);
      span.innerHTML = "Subject/course code";
      el.className = "form__label form_lable_s";
      var div = document.getElementById("autocomplete");
      insertAfter(div, el);
    }
}

$('#autocomplete').click(function() {
  $(this).focus().removeClass('subject-placeholder');
});

	// $.ajax({
	//     method: "POST",
	//     url:DOMAIN_NAME+"csrf-ajax.php",
	//     success: function(response) {
	//     	//console.log(response);
	//         $(".csrf_token").val(response);
	//     }
	// });

    // if(fooCountry){
    //     $.ajax({
    //         method: "GET",
    //         url:DOMAIN_NAME+"inclib/newfront-uk.php?Country="+fooCountry,
    //         success: function(response) {
    //             //console.log(response);
    //             localStorage.setItem("newfrontpopreviews", response);
    //             // $(".csrf_token").val(response);
    //         }
    //     });
    // }


    $('.offerButton').on('click', function(e){
        //console.log(e.date);
        $("body").removeClass("isOffer");
    });


    

});


(function($){
    $(document).ready(function() {
        $(document).scrollzipInit();
        $(document).rollerInit();
    });
    $(document).on("load scroll resize", function(){
        $('.numscroller').scrollzip({
            showFunction    :   function() {
                                    numberRoller($(this).attr('data-slno'));
                                },
            wholeVisible    :     false,
        });
    });
    $.fn.scrollzipInit=function(){
        $('body').prepend("<div style='position:fixed;top:0px;left:0px;width:0;height:0;' id='scrollzipPoint'></div>" );
    };
    $.fn.rollerInit=function(){
        var i=0;
        $('.numscroller').each(function() {
            i++;
           $(this).attr('data-slno',i);
           $(this).addClass("roller-title-number-"+i);
        });
    };
    $.fn.scrollzip = function(options){
        var settings = $.extend({
            showFunction    : null,
            hideFunction    : null,
            showShift       : 0,
            wholeVisible    : false,
            hideShift       : 0,
        }, options);
        return this.each(function(i,obj){
            $(this).addClass('scrollzip');
            if ( $.isFunction( settings.showFunction ) ){
                if(
                    !$(this).hasClass('isShown')&&
                    ($(window).outerHeight()+$('#scrollzipPoint').offset().top-settings.showShift)>($(this).offset().top+((settings.wholeVisible)?$(this).outerHeight():0))&&
                    ($('#scrollzipPoint').offset().top+((settings.wholeVisible)?$(this).outerHeight():0))<($(this).outerHeight()+$(this).offset().top-settings.showShift)
                ){
                    $(this).addClass('isShown');
                    settings.showFunction.call( this );
                }
            }
            if ( $.isFunction( settings.hideFunction ) ){
                if(
                    $(this).hasClass('isShown')&&
                    (($(window).outerHeight()+$('#scrollzipPoint').offset().top-settings.hideShift)<($(this).offset().top+((settings.wholeVisible)?$(this).outerHeight():0))||
                    ($('#scrollzipPoint').offset().top+((settings.wholeVisible)?$(this).outerHeight():0))>($(this).outerHeight()+$(this).offset().top-settings.hideShift))
                ){
                    $(this).removeClass('isShown');
                    settings.hideFunction.call( this );
                }
            }
            return this;
        });
    };
    function numberRoller(slno){
            var min=$('.roller-title-number-'+slno).attr('data-min');
            var max=$('.roller-title-number-'+slno).attr('data-max');
            var timediff=$('.roller-title-number-'+slno).attr('data-delay');
            var increment=$('.roller-title-number-'+slno).attr('data-increment');
            var numdiff=max-min;
            var timeout=(timediff*1000)/numdiff;
            //if(numinc<10){
                //increment=Math.floor((timediff*1000)/10);
            //}//alert(increment);
            numberRoll(slno,min,max,increment,timeout);

    }
    function numberRoll(slno,min,max,increment,timeout){//alert(slno+"="+min+"="+max+"="+increment+"="+timeout);
        if(min<=max){
            $('.roller-title-number-'+slno).html(min);
            min=parseInt(min)+parseInt(increment);
            setTimeout(function(){numberRoll(eval(slno),eval(min),eval(max),eval(increment),eval(timeout))},timeout);
        }else{
            $('.roller-title-number-'+slno).html(max);
        }
    }
})(jQuery);

if (screen.width >= 768) {
// $(function(){
//   wow = new WOW(
//     {
//       boxClass:     'wow',      // default
//       animateClass: 'newAnimated', // default
//       offset:       0,          // default
//       mobile:       false,       // default
//       live:         true        // default
//     }
//   )
//   wow.init();

// });

$(window).ready(function(){
  setInterval(function(){
    $('.banner__right .shapes').addClass("active");
    $('.banner__right .formShape').addClass("active")
  }, 2000);

});
}




$(function() {
var owl = $('.subjects .preferSlider, .prefer .preferSlider, .howitsworks .preferSlider, .howitsworks .sliderInMobile'),
owlOptions = {
  loop: false,
  margin: 0,
  smartSpeed: 700,
  dots:true,
  nav: false,
  items: 1,
  onTranslated: animateSlide,
onTranslate: removeAnimation
};

if ( $(window).width() < 768 ) {
  var owlActive = owl.owlCarousel(owlOptions);
} else {
  owl.addClass('off');
}
})



// Other Slides
function removeAnimation() {
var item = $(".owl-item");
item.removeClass(item.children().data('animate'));

}
function animateSlide() {
var item = $(".owl-item.active");
item.addClass(item.children().data('animate'));
}

if($('.dev-server-errorbox')!=null){
setTimeout(function () {
$('.dev-server-errorbox').hide();
},4000);
}

      $(document).ready(function() {
          // console.log('test owl');
        $('.accomplishedSlider').owlCarousel({
          stagePadding: 0,
          margin: 0,
          nav: false,
          center: true,
          dots:false,
          autoplay:true,
          loop: true,
          autoWidth:true,
          responsive: {
            0: {
              items: 1,
              center: true,
              loop: true
            },
            600: {
              items: 3,
              center: true,
              loop: true,
              margin: 30
            },
            1000: {
              items: 3,
              autoWidth:false,
              margin: 0
            }
          }
        })

        $('.logoSlider').owlCarousel({
          margin: 10,
          nav: false,
          dots:false,
          autoplay:true,
          loop: true,
          autoplayTimeout:2000,
          autoplayHoverPause:false,
          autoWidth:true,
          responsive: {
            0: {
              items: 1,
              center: true,
              loop: true
            },
            600: {
              items: 3,
              center: false,
              loop: true,
              autoWidth:true
            },
            1000: {
              items: 7,
              autoWidth:false,
              margin: 30
            }
          }
        })

        $('.latestCourseSlider').owlCarousel({
          margin: 54,
          nav: true,
          items: 1,
          dots:false,
          autoplay:false,
          loop: false,
          navText: [
              '<span class="hex"></span>',
              '<span class="hex"></span>'
          ],
          navContainer: '#latestCourses .slider_nav'
        })

        $('.latestCourseSliderMobile').owlCarousel({
          margin: 30,
          stagePadding: 20,
          nav: false,
          items: 1,
          dots:false,
          autoplay:false,
          loop: false,
          responsive: {
            0: {
              items: 1,
              margin: 20,
            },
            600: {
              items: 2,
              margin: 20,
            },
            1000: {
              items: 1,
            }
          }
        })

        $(' .popularCourseSlider').owlCarousel({
          margin: 54,
          nav: true,
          items: 1,
          dots:false,
          autoplay:false,
          loop: false,
          navText: [
              '<span class="hex"></span>',
              '<span class="hex"></span>'
          ],
          navContainer: '#popularCourses .slider_nav'
        })

        $('.expertSlider').owlCarousel({
          stagePadding: 20,
          nav: false,
          autoplay:true,
          loop: false,
          dots: false,
          navText: [
            '<span class="hex"></span>',
            '<span class="hex"></span>'
          ],
          navContainer: '.experts__inner  .slider_nav',
          responsive: {
            0: {
              items: 1,
              margin: 20,
            },
            600: {
              items: 2,
              margin: 20,
              stagePadding: 30
            },
            1000: {
              items: 3,
              margin:56,
              nav: true
            }
          }
        })
        $('.testimonialSlider').owlCarousel({

          nav: true,
          autoplay:true,
          loop: true,
          dots:false,
          autoplayTimeout:5000,
          autoplayHoverPause:false,
          rewindNav : false,
          navText: [
  '<span class="hex"></span>',
  '<span class="hex"></span>'
],
navContainer: '.testimonial .slider_nav',
          responsive: {
            0: {
              items: 1,
              margin:20,
              stagePadding: 20
            },
            600: {
              items: 1,
              margin: 30,
              stagePadding: 20,
              autoWidth:false,

            },
            1000: {
              autoWidth:true,
              stagePadding: 50,
              items: 2,
              margin: 56

            }
          }
        })
        // // Show the first tab by default
        // $('.tabs-stage div').hide();
        // $('.tabs-stage div:first').show();
        // $('.tabs-nav li:first').addClass('tab-active');

        // // Change tab class and display content
        // $('.tabs-nav a').on('click', function(event){
        //   event.preventDefault();
        //   $('.tabs-nav li').removeClass('tab-active');
        //   $(this).parent().addClass('tab-active');
        //   $('.tabs-stage div').hide();
        //   $($(this).attr('href')).show();
        // });

      })

      $(document).ready(function() {

        $(".seta > a").on("click", function() {
          if ($(this).hasClass("active")) {
            $(this).removeClass("active");
            $(this)
              .siblings(".content")
              .slideUp(200);
            $(".seta > a i")
              .removeClass("fa-minus")
              .addClass("fa-plus");
          } else {
            $(".seta > a i")
              .removeClass("fa-minus")
              .addClass("fa-plus");
            $(this)
              .find("i")
              .removeClass("fa-plus")
              .addClass("fa-minus");
            $(".seta > a").removeClass("active");
            $(this).addClass("active");
            $(".content").slideUp(200);
            $(this)
              .siblings(".content")
              .slideDown(200);
          }
        });



        $(function() {
          var owl = $('.preferSlider'),
            owlOptions = {
              loop: false,
              margin: 0,
              smartSpeed: 700,
              dots:true,
              nav: false,
              items: 1
            };

          if ( $(window).width() < 768 ) {
              var owlActive = owl.owlCarousel(owlOptions);
          } else {
              owl.addClass('off');
          }

          $(window).resize(function() {
              if ( $(window).width() < 768 ) {
                  if ( $('.owl-carousel').hasClass('off') ) {
                      var owlActive = owl.owlCarousel(owlOptions);
                      owl.removeClass('off');
                  }
              } else {
                  if ( !$('.owl-carousel').hasClass('off') ) {
                      owl.addClass('off').trigger('destroy.owl.carousel');
                      owl.find('.owl-stage-outer').children(':eq(0)').unwrap();
                  }
              }
          });
        });
        $('.staticSlider').owlCarousel({
          stagePadding: 30,
          margin: 30,
          dots:false,
          nav: false,
          autoplay:false,
          autoWidth:true,
          loop: false,
          responsive: {
            0: {
              items: 3
            },
            600: {
              items: 3
            },
            1000: {
              items: 3
            }
          }
        })

      });

      $(function() {
        var owl = $('.studentSeeking .preferSlider'),
            owlOptions = {
                loop: false,
                stagePadding: 20,
                dots:false,
                nav: false,
                margin: 20,
                responsive: {
                    0: {
                        items: 1
                    }
                }
            };

        if ( $(window).width() < 854 ) {
            var owlActive = owl.owlCarousel(owlOptions);
        } else {
            owl.addClass('off');
        }

        $(window).resize(function() {
            if ( $(window).width() < 854 ) {
                if ( $('.owl-carousel').hasClass('off') ) {
                    var owlActive = owl.owlCarousel(owlOptions);
                    owl.removeClass('off');
                }
            } else {
                if ( !$('.owl-carousel').hasClass('off') ) {
                    owl.addClass('off').trigger('destroy.owl.carousel');
                    owl.find('.owl-stage-outer').children(':eq(0)').unwrap();
                }
            }
        });
    });









    $(function() {
    var owl = $('.popular-courseSlider'),
        owlOptions = {
            margin: 20,
            nav: false,
            dots:false,
            //autoplay:true,
            // loop: true,
            // autoWidth:true,
            itemClass: 'slider-item',
            responsive: {
                0: {
                  items: 1,
                  dots:true,
                  stagePadding: 34,
                //   center: true,
                //   loop: true,


                },
                600: {
                    items: 3,
                    dots:true,
                    stagePadding: 34,
                },
                1000: {
                  items: 7,
                  autoWidth:true,
                  margin: 30
                }
              }
        };

    if ( $(window).width() < 854 ) {
        var owlActive = owl.owlCarousel(owlOptions);
    } else {
        owl.addClass('off');
    }

    $(window).resize(function() {
        if ( $(window).width() < 854 ) {
            if ( $('.popular-courseSlider').hasClass('off') ) {
                var owlActive = owl.owlCarousel(owlOptions);
                owl.removeClass('off');
            }
        } else {
            if ( !$('.popular-courseSlider').hasClass('off') ) {
                owl.addClass('off').trigger('destroy.owl.carousel');
                owl.find('.owl-stage-outer').children(':eq(0)').unwrap();
            }
        }
    });
});
jQuery(function ($) {
  // custom formatting example
  (function ($) {
  $.fn.countTo = function (options) {
    options = options || {};

    return $(this).each(function () {
      // set options for current element
      var settings = $.extend({}, $.fn.countTo.defaults, {
        from:            $(this).data('from'),
        to:              $(this).data('to'),
        speed:           $(this).data('speed'),
        refreshInterval: $(this).data('refresh-interval'),
        decimals:        $(this).data('decimals')
      }, options);

      // how many times to update the value, and how much to increment the value on each update
      var loops = Math.ceil(settings.speed / settings.refreshInterval),
        increment = (settings.to - settings.from) / loops;

      // references & variables that will change with each update
      var self = this,
        $self = $(this),
        loopCount = 0,
        value = settings.from,
        data = $self.data('countTo') || {};

      $self.data('countTo', data);

      // if an existing interval can be found, clear it first
      if (data.interval) {
        clearInterval(data.interval);
      }
      data.interval = setInterval(updateTimer, settings.refreshInterval);

      // initialize the element with the starting value
      render(value);

      function updateTimer() {
        value += increment;
        loopCount++;

        render(value);

        if (typeof(settings.onUpdate) == 'function') {
          settings.onUpdate.call(self, value);
        }

        if (loopCount >= loops) {
          // remove the interval
          $self.removeData('countTo');
          clearInterval(data.interval);
          value = settings.to;

          if (typeof(settings.onComplete) == 'function') {
            settings.onComplete.call(self, value);
          }
        }
      }

      function render(value) {
        var formattedValue = settings.formatter.call(self, value, settings);
        $self.html(formattedValue);
      }
    });
  };

  $.fn.countTo.defaults = {
    from: 0,               // the number the element should start at
    to: 0,                 // the number the element should end at
    speed: 1000,           // how long it should take to count between the target numbers
    refreshInterval: 100,  // how often the element should be updated
    decimals: 0,           // the number of decimal places to show
    formatter: formatter,  // handler for formatting the value before rendering
    onUpdate: null,        // callback method for every time the element is updated
    onComplete: null       // callback method for when the element finishes updating
  };

  function formatter(value, settings) {
    return value.toFixed(settings.decimals);
  }
}(jQuery));
  $('.count-number').data('countToOptions', {
  formatter: function (value, options) {
    return value.toFixed(options.decimals).replace(/\B(?=(?:\d{3})+(?!\d))/g, ',');
  }
  });

  // start all the timers
  $('.timer').each(count);

  function count(options) {
  var $this = $(this);
  options = $.extend({}, options || {}, $this.data('countToOptions') || {});
  $this.countTo(options);
  }

});